module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.prefixCls],
    on: {
      "mouseenter": _vm.handleShowPopper,
      "mouseleave": _vm.handleClosePopper
    }
  }, [_c('div', {
    ref: "reference",
    class: [_vm.prefixCls + '-rel']
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.disabled && (_vm.visible || _vm.always)),
      expression: "!disabled && (visible || always)"
    }],
    ref: "popper",
    class: [_vm.prefixCls + '-popper']
  }, [_c('div', {
    class: [_vm.prefixCls + '-content']
  }, [_c('div', {
    class: [_vm.prefixCls + '-arrow']
  }), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-inner']
  }, [_vm._t("content", [_vm._v(_vm._s(_vm.content))])], 2)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b2a241a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/tooltip/tooltip.vue
// module id = 660
// module chunks = 1